(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs-webpienet"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

    class TabsWebPienet {

        constructor(section) {

            this.section = section;

            this.desktopTabs = [
                ...section.querySelectorAll('.tabs-webpienet-tab-button')
            ];

            this.desktopPanels = [
                ...section.querySelectorAll('.tabs-webpienet-panel')
            ];

            this.mobileTriggers = [
                ...section.querySelectorAll('.tabs-webpienet-mobile-trigger')
            ];

            this.init();

        }


        init() {

    this.bindDesktopTabs();

    this.bindMobileAccordion();

    this.bindKeyboardNavigation();

    this.openHashTab();

    this.bindThemeEditor();

        }



        /*------------------------------------
        Desktop Tabs
        ------------------------------------*/

        bindDesktopTabs() {

            this.desktopTabs.forEach(tab => {

                tab.addEventListener('click', () => {

                    const id = tab.dataset.tab;

                    this.activateDesktopTab(id);

                });

            });

        }



        activateDesktopTab(id) {

            this.desktopTabs.forEach(tab => {

                const active = tab.dataset.tab === id;

                tab.classList.toggle('is-active', active);

                tab.setAttribute(
                    'aria-selected',
                    active
                );

            });

            this.desktopPanels.forEach(panel => {

                panel.classList.toggle(
                    'is-active',
                    panel.dataset.tabContent === id
                );

            });

        }



        /*------------------------------------
        Mobile Accordion
        ------------------------------------*/

        bindMobileAccordion() {

            this.mobileTriggers.forEach(trigger => {

                trigger.addEventListener('click', () => {

                    const panel =
                        trigger.nextElementSibling;

                   const isOpen = trigger.classList.contains('is-open');

if (isOpen) {

    trigger.classList.remove('is-open');

    trigger.setAttribute(
        'aria-expanded',
        'false'
    );

    if (panel) {
        panel.style.maxHeight = '0px';
    }

    return;
}

                    trigger.classList.add('is-open');

                    trigger.setAttribute(
                        'aria-expanded',
                        'true'
                    );

                    if(panel){

                        panel.style.maxHeight =
                            panel.scrollHeight + 'px';

                    }

                });

            });

        }

        /*==============================================================
PART 5.2 GOES HERE
Keyboard Navigation
Hash Navigation
Theme Editor
==============================================================*/

/*------------------------------------
Keyboard Navigation
------------------------------------*/

bindKeyboardNavigation() {

    this.desktopTabs.forEach((tab, index) => {

        tab.addEventListener('keydown', (event) => {

            let target = null;

            switch (event.key) {

                case 'ArrowRight':
                    target = this.desktopTabs[index + 1] || this.desktopTabs[0];
                    break;

                case 'ArrowLeft':
                    target = this.desktopTabs[index - 1] || this.desktopTabs[this.desktopTabs.length - 1];
                    break;

                case 'Home':
                    target = this.desktopTabs[0];
                    break;

                case 'End':
                    target = this.desktopTabs[this.desktopTabs.length - 1];
                    break;

                case 'Enter':
                case ' ':
                    event.preventDefault();
                    tab.click();
                    return;

                default:
                    return;

            }

            event.preventDefault();

            target.focus();

            target.click();

        });

    });

}



/*------------------------------------
Hash Navigation
------------------------------------*/

openHashTab() {

    if (!window.location.hash) return;

    const hash = window.location.hash.substring(1).toLowerCase();

    const targetTab = this.desktopTabs.find(tab => {

        const title = tab.textContent
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '-');

        return title === hash;

    });

    if (targetTab) {

        targetTab.click();

    }

}



/*------------------------------------
Theme Editor Support
------------------------------------*/

bindThemeEditor() {

    document.addEventListener('shopify:block:select', (event) => {

        const block = event.target;

        if (!block) return;

        const panel = block.closest('.tabs-webpienet-panel');

        if (!panel) return;

        const panelId = panel.dataset.tabContent;

        this.activateDesktopTab(panelId);

        const mobileTrigger = this.section.querySelector(
            '[data-mobile-tab="' + panelId + '"]'
        );

        if (mobileTrigger) {

            mobileTrigger.classList.add('is-open');

            mobileTrigger.setAttribute(
                'aria-expanded',
                'true'
            );

            const content = mobileTrigger.nextElementSibling;

            if (content) {

                content.style.maxHeight =
                    content.scrollHeight + 'px';

            }

        }

        panel.scrollIntoView({

            behavior: 'smooth',

            block: 'center'

        });

    });

}

    }



    /*------------------------------------
    Initialize Every Section
    ------------------------------------*/

    document
        .querySelectorAll('.tabs-webpienet-section')
        .forEach(section => {

            new TabsWebPienet(section);

        });

});


  } catch(e) { console.error(e); }
})();
})();
